import assign from 'lodash/assign';

import template from './calendlyModal.html';
import './calendlyModal.scss';

export const CalendlyModalModule = angular
    .module('app.components.calendlyModal', [
        'ngMaterial'
    ])
    .component('calendlyModal', {
        template,
        bindings: {
            link: '<'
        },
        controller: class CalendlyModal {
            constructor($mdDialog) {
                assign(this, {
                    $mdDialog
                });
            }

            close() {
                this.$mdDialog.cancel();
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/calendlyLauncher/calendlyModal.component.js